import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

export const uploadHotelPaymentScanner = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotels/payment-scanner/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data.publicUrl;
};

export const uploadHotelRoomCategoryImages = async (categoryId, files) => {
  const formData = new FormData();
  Array.from(files || []).forEach((file) => formData.append("files", file));
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotels/room-categories/${categoryId}/images/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
};

export const deleteHotelRoomCategoryImage = async (imageId) => {
  await axios.delete(`${API_BASE_URL}/api/admin/hotels/room-categories/images/${imageId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
    },
  });
};
